import React, { FunctionComponent, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useTemplate, useTemplateList } from '___hooks'
import { Spinner, TemplatePlaceholder } from 'assets/svgIconComponents'
import { Button, Select } from 'components/CasusComponents'
import {
  MainLayoutRightPaneTemplateRelocationModalContentProps,
  mainLayoutRightPaneTemplateRelocationModalContentClasses as classes,
} from 'Layouts/___MainLayout'
import Info from './Info'

export const ModalContent: FunctionComponent<MainLayoutRightPaneTemplateRelocationModalContentProps> = React.memo(({ id, cancel, conclude }) => {
  const { t: translate } = useTranslation('translation', { keyPrefix: '' })
  const [folderId, setFolderId] = useState<string>()
  const {
    folders: { data },
  } = useTemplateList()
  const { data: template, previewImageSrcURL: { data: src, isLoading: imageLoading } = {} } = useTemplate(id!)

  const preview = useMemo(() => {
    if (imageLoading) return <Spinner />
    if (src) return <img src={src} alt="Template Preview" />
    return <TemplatePlaceholder randomize />
  }, [imageLoading, src])

  const currentCategory = useMemo(
    () => (Array.isArray(template?.category) ? (template!.category as string[])[0] : template?.category) || '',
    [template]
  )
  const folders = useMemo(
    () =>
      data?.reduce(
        (result, folder) => (folder.id !== currentCategory ? Object.assign(result, { [folder.id]: folder.name }) : result),
        Object.assign({}, currentCategory ? { unnest: translate('remove-from-folder') } : undefined)
      ) || {},
    [data, currentCategory, translate]
  )

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.info}>
          {preview}
          <Info id={id} renaming={false} renameCallback={() => {}} />
        </div>
      </div>
      <div className="Modal-footer">
        <Select className={classes.select} options={folders} value={folderId} placeholder={translate('select-folder')} onSelect={setFolderId} />
        <Button onClick={cancel}>Cancel</Button>
        <Button onClick={() => conclude(folderId === 'unnest' ? '' : folderId)} disabled={!folderId ? true : undefined} primary>
          Move Document
        </Button>
      </div>
    </>
  )
})

ModalContent.displayName = 'MainLayout-RightPane-Template-Publishing-ModalContent'

export default ModalContent
